import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 * Marks a field as "newly added, not yet saved". While a field is new, editing
 * its label still drives the key (a convenience for fresh fields). Once saved,
 * the flag is cleared and label edits no longer touch the key — the user edits
 * it explicitly.
 *
 * The flag is a NON-ENUMERABLE property so it never serializes into the form
 * JSON, and it survives refreshFormlyForm (which shallow-copies the array but
 * keeps field object references). A field reloaded from saved JSON has no flag,
 * so it correctly reads as "existing".
 */
const FB_NEW_FIELD_FLAG = '__fbNewField';

export function markFieldAsNew(field: FormlyFieldConfig): void {
  Object.defineProperty(field, FB_NEW_FIELD_FLAG, {
    value: true,
    enumerable: false,
    writable: true,
    configurable: true,
  });
}

export function isFieldNew(
  field: FormlyFieldConfig | null | undefined
): boolean {
  return (
    !!field && (field as Record<string, unknown>)[FB_NEW_FIELD_FLAG] === true
  );
}

export function clearFieldNew(
  field: FormlyFieldConfig | null | undefined
): void {
  if (field && Object.prototype.hasOwnProperty.call(field, FB_NEW_FIELD_FLAG)) {
    (field as Record<string, unknown>)[FB_NEW_FIELD_FLAG] = false;
  }
}
